import React, { ReactNode } from "react";
import { Stack, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";

export interface TextOnImageProps {
  image: string;
  content: ReactNode;
}
const useStyles = makeStyles(() => ({
  header: {
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  overlay: {
    height: "100%",
    background: `#4444445e`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));
const TextOnImage = ({ image, content }: TextOnImageProps) => {
  const classes = useStyles({ image });
  return (
    <Stack height="100%" className={classes.header} style={{ backgroundImage: `url(${image})` }}>
      <Box className={classes.overlay} px={2} py={3}>
        <Box className="border-1-white" px={1.5} py={1} height="100%">
          {content}
        </Box>
      </Box>
    </Stack>
  );
};
export default TextOnImage;
